var name = "Scarlet 301_3B6Pv1";
var uuid = "b3268550-97bf-4821-b64b-f8b20a4d7119";
var pos = [
	0,
	0,
	0
];
var rot = [
	0,
	0,
	0
];
var size = [
	15.575,
	3.0475,
	9.775
];
var anchor = [
	0.5,
	0,
	0.7953964177628271
];
var color = "#ff671f";
var alpha = 1;
var rg = true;
var type = "Apartment";
var children = [
	{
		name: "balcony",
		uuid: "4e013545-cff1-4c8e-a92b-abe213b446ce",
		pos: [
			-7.5125,
			0.145,
			-7.775
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			11.125,
			0.16,
			1.5
		],
		anchor: [
			0,
			0,
			0
		],
		color: "#cccccc",
		alpha: 1,
		rg: true,
		type: "Balcony",
		children: [
			{
				name: "floor",
				uuid: "ab2ac907-a211-4c0b-b0e5-3284176dff3c",
				pos: [
					9.4625,
					0.08,
					0.75
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.325,
					0.16,
					1.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "BFA|01|",
				type: "Floor"
			},
			{
				name: "floor",
				uuid: "d554af21-067f-4733-af74-54828a87ea2c",
				pos: [
					1.6625,
					0.08,
					0.75
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.325,
					0.16,
					1.5
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "BFA|01|",
				type: "Floor"
			}
		]
	},
	{
		name: "Bedroom Double",
		uuid: "f93f5a64-180f-4a74-bc40-fa43efb6680c",
		pos: [
			1.95,
			0.305,
			-4.135
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.6,
			2.4384,
			3.405
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble"
		}
	},
	{
		name: "M4(2) Bathroom",
		uuid: "8a15d473-5ad3-4c18-9b53-6af5070e76c9",
		pos: [
			-6.65,
			0.305,
			-1.2375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			2,
			2.4384,
			2.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#fe4365",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Bathroom"
		}
	},
	{
		name: "Kitchen / Living / Dining",
		uuid: "0cc101e8-47a0-43dc-b982-55ae49db659c",
		pos: [
			5.85,
			0.305,
			-2.7375
		],
		rot: [
			0,
			180,
			0
		],
		size: [
			3.6,
			2.4384,
			9.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#00a0b0",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "KitchenLivingDining"
		}
	},
	{
		name: "Storage",
		uuid: "ab01bee5-91a5-4e68-ab02-fd96331e3d75",
		pos: [
			-1.1025,
			0.305,
			-0.5375
		],
		rot: [
			0,
			90,
			0
		],
		size: [
			0.8,
			2.4384,
			1.905
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "Utility",
		uuid: "898fde16-a504-42c3-830e-622ebad98caf",
		pos: [
			-2.95,
			0.305,
			-0.5375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			1.6,
			2.4384,
			0.8
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#c44d58",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Utility"
		}
	},
	{
		name: "Hallway",
		uuid: "a369be4f-45ea-4fc4-a939-467dcd4ebe4f",
		pos: [
			-0.8213,
			0.305,
			-1.2375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			9.4675,
			2.4384,
			2.2
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#4ecdc4",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Hallway",
			polygon: [
				[
					3.75,
					0.305,
					-1.2375
				],
				[
					3.9125,
					0.305,
					-1.2375
				],
				[
					3.9125,
					0.305,
					-2.3375
				],
				[
					-5.555,
					0.305,
					-2.3375
				],
				[
					-5.555,
					0.305,
					-1.0325
				],
				[
					-4.05,
					0.305,
					-1.0325
				],
				[
					-4.05,
					0.305,
					-1.2375
				],
				[
					-3.75,
					0.305,
					-1.2375
				],
				[
					-3.75,
					0.305,
					-1.0325
				],
				[
					-0.15,
					0.305,
					-1.0325
				],
				[
					-0.15,
					0.305,
					-1.2375
				],
				[
					0.15,
					0.305,
					-1.2375
				],
				[
					0.15,
					0.305,
					-1.0325
				],
				[
					1.8725,
					0.305,
					-1.0325
				],
				[
					1.8725,
					0.305,
					-0.1375
				],
				[
					3.75,
					0.305,
					-0.1375
				],
				[
					3.75,
					0.305,
					-1.2375
				]
			]
		}
	},
	{
		name: "Bedroom Double",
		uuid: "58c4122e-1fe0-4f5a-85c8-89e338d7a1d7",
		pos: [
			-5.85,
			0.305,
			-4.135
		],
		rot: [
			0,
			180,
			0
		],
		size: [
			3.6,
			2.4384,
			3.405
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble"
		}
	},
	{
		name: "Bedroom Double",
		uuid: "1426db09-dd23-4b60-9166-909f014c9b5a",
		pos: [
			-1.95,
			0.305,
			-4.885
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.6,
			2.4384,
			4.905
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#a7dbd8",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "BedroomDouble",
			polygon: [
				[
					-0.15,
					0.305,
					-7.3375
				],
				[
					-3.75,
					0.305,
					-7.3375
				],
				[
					-3.75,
					0.305,
					-5.9063
				],
				[
					-3.75,
					0.305,
					-3.9325
				],
				[
					-1.5525,
					0.305,
					-3.9325
				],
				[
					-1.5525,
					0.305,
					-2.4325
				],
				[
					-0.15,
					0.305,
					-2.4325
				],
				[
					-0.15,
					0.305,
					-5.9063
				],
				[
					-0.15,
					0.305,
					-7.3375
				]
			]
		}
	},
	{
		name: "WC",
		uuid: "3bca5819-af75-4704-b50f-e327d24334b8",
		pos: [
			-2.6988,
			0.305,
			-3.135
		],
		rot: [
			0,
			-90,
			0
		],
		size: [
			1.405,
			2.4384,
			2.1025
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#fc9d9a",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "WC"
		}
	},
	{
		name: "Storage",
		uuid: "61746d4b-a5d3-4fab-901f-d374dc0514ed",
		pos: [
			0.9637,
			0.305,
			-0.5375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			1.6275,
			2.4384,
			0.8
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "Storage",
		uuid: "b50cf150-28e8-46ef-9602-85f26879d8ff",
		pos: [
			-4.8025,
			0.305,
			-0.5375
		],
		rot: [
			0,
			90,
			0
		],
		size: [
			0.8,
			2.4384,
			1.505
		],
		anchor: [
			0.5,
			0,
			0.5
		],
		color: "#556270",
		alpha: 1,
		rg: true,
		children: [
		],
		type: "Room",
		data: {
			type: "Storage"
		}
	},
	{
		name: "module",
		uuid: "6a3ad602-70cc-4214-a33c-d931fb003927",
		pos: [
			-5.85,
			1.5238,
			-2.9875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.0475,
			5.975
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#ff671f",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "d2ca6d8d-8f56-4468-b16a-c7ab8e936622",
				pos: [
					0,
					0.0712,
					-2.9187
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "7a7faa97-a8ae-47eb-8039-e71b16c460e9",
						pos: [
							0,
							-0.2525,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.75,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0003",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "41d988b1-fc74-44cd-8de1-b7bdaf9bf641",
				pos: [
					1.8687,
					0.0712,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					5.8375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "fa0d48a0-acd7-4b1e-bb40-a38589d8200f",
						pos: [
							1.3188,
							-0.2825,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "11074c8e-dd44-46b9-b932-6cbcfd22f2f5",
				pos: [
					0.0688,
					0.0712,
					2.9188
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "98f52711-9a9c-4b65-bf34-e47709e6af1c",
				pos: [
					-1.8687,
					0.0712,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.975,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "84bad10d-9eb8-4dac-aec4-144597d7c7fc",
				pos: [
					0,
					0.0687,
					0.6025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "13bff256-9d03-4a49-806b-8eedb53acaf3",
						pos: [
							1.245,
							-0.225,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.91,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0003",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "82585619-dbd6-475d-8945-b372e50596a1",
				pos: [
					0.2475,
					0.0687,
					1.75
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					2.2,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "37707bee-49c8-496b-9a91-d89ae0691065",
						pos: [
							-0.545,
							-0.225,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.91,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0003",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "906e671a-825b-4297-aecc-8702a816b8e8",
				pos: [
					1.0475,
					0.0687,
					2.0025
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					1.505,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "2567c74e-ecce-4e9b-9772-f9cc40c86cad",
						pos: [
							0.1075,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "f95cd313-85e8-4bb8-8921-f2895ccf7d4c",
				pos: [
					0,
					-1.2613,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "floor",
				uuid: "2277c473-88f4-4fe8-ad28-a39e16ad6988",
				pos: [
					0,
					-1.2238,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "f270b559-3240-46c8-9338-3a10b8fc1c81",
				pos: [
					0,
					-1.4088,
					-2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "fed98a75-aaa0-4ed2-8ad4-8fe26062145c",
				pos: [
					0,
					-1.4088,
					2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "fa443109-e93f-496e-8773-5a5e8d3a66fc",
				pos: [
					0,
					-1.3733,
					-1.3512
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "2ed0dac1-04a8-42bc-b629-a5926eeab1bb",
				pos: [
					0,
					-1.3733,
					-1.5987
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "20c89719-2dd5-475a-a9da-1abea3c5af45",
				pos: [
					0,
					-1.3733,
					2.7988
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "63f77312-3c69-4ef2-a841-006dbea811e7",
				pos: [
					0,
					-1.3733,
					2.5513
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "c98d8331-da5a-4229-accb-aea3f1a10d93",
				pos: [
					0,
					-1.3608,
					-2.8425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.44,
					0.1,
					0.075
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "LAU|01|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "f79f4d08-ceff-4495-8e3a-e14f2db49dc7",
				pos: [
					0,
					-1.3608,
					0.0562
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "f655065f-b102-4dda-ad0f-60c27a29cce0",
				pos: [
					0,
					-1.3608,
					-0.0037
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "fb1a9ce8-cc1a-4b3a-8782-1913a694db2e",
				pos: [
					0,
					-1.3608,
					1.3563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "6beba23d-e73f-457a-91a1-56cf88facdef",
				pos: [
					0,
					-1.3608,
					1.2963
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "77a778f4-75b3-47f8-9798-76b8cba9eeb2",
				pos: [
					-1.875,
					-1.4088,
					0.0006
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7613,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "5d499191-e16d-423c-8b8f-96e32a8b8647",
				pos: [
					1.875,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "54a5f8fb-81d8-4c1c-9005-0c620f01f388",
				pos: [
					-1.875,
					0.08,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "6c24cfe9-26c9-428f-bd3b-2ddff276a2b6",
				pos: [
					-1.875,
					0.08,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "0fc3c11d-17b8-411a-986a-9da0034a4ed9",
				pos: [
					1.875,
					0.08,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "4408f194-1f0d-409b-b0a5-74e6a77a9587",
				pos: [
					1.875,
					0.08,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "ceiling",
				uuid: "166b44ff-1f3a-4120-ad69-6cc83d319929",
				pos: [
					0,
					1.4463,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "d3a112be-546c-46d1-8134-0caca71dc7d8",
		pos: [
			1.95,
			1.5238,
			-2.9875
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.0475,
			5.975
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#ff671f",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "24189463-1cf5-448c-9f7d-26c04c79a18f",
				pos: [
					0,
					0.0687,
					0.6025
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "9cbc7c63-e80f-4bfc-b5ca-e85e7a2b9a96",
						pos: [
							1.2,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "df30036c-3727-4edd-b75b-03ebe5916d62",
				pos: [
					0,
					0.0712,
					-2.9187
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "28f58d1b-c85f-409b-89fd-5f4c3a8b2955",
						pos: [
							0,
							-0.2525,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.75,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DCD|01|UK-DCD0003",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "07a423d2-dcda-41ae-9da0-38e38cff0049",
				pos: [
					1.8687,
					0.0712,
					-0.0688
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					5.8375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "882df035-474f-465d-85db-f8b272752f60",
						pos: [
							1.3188,
							-0.2825,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "6237e4bf-46d9-41dd-8949-4aefc0b04420",
				pos: [
					0.0688,
					0.0712,
					2.9188
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "c6b2d43c-6e2b-456e-93e0-225d4e7a7624",
						pos: [
							1.0262,
							-0.2275,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.01,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|01|UK-DIS0001",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: true
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "d63253ee-0f4c-4e02-a6c9-525175342083",
				pos: [
					-1.8688,
					0.0712,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.975,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "1cf306c6-c9bd-4d46-ba59-cc5a57438a66",
						pos: [
							-1.25,
							-0.245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.09,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "663acb70-7309-46e8-ab1e-75139e95845a",
				pos: [
					-0.125,
					0.0687,
					2.4025
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					0.895,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "46855e9a-c552-4b84-8c66-cc6025433946",
				pos: [
					-0.9863,
					0.0687,
					2.0025
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					1.6275,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "f924b7d3-1ebd-42a1-8918-2a315a8664a3",
						pos: [
							0.0138,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "7a59012e-e26d-4994-a7c3-a0750fe8ba9f",
				pos: [
					0,
					-1.2613,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "floor",
				uuid: "d635ec2e-2346-418e-acde-b5ffac09b874",
				pos: [
					0,
					-1.2238,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "f3daeaf1-8f23-49af-9e8b-51ebfe69ada5",
				pos: [
					0,
					-1.4088,
					-2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "721ab293-793f-4c5c-b8ca-aa20bcf5da63",
				pos: [
					0,
					-1.4088,
					2.925
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "15219fbf-37f3-4032-8f10-9abfe446bf04",
				pos: [
					0,
					-1.3733,
					-1.3512
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "cd7b005a-41b0-4ddf-b87a-0c02de703a3c",
				pos: [
					0,
					-1.3733,
					-1.5987
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "8ecdbf87-bdc0-430a-9d2d-eb9c3911ee66",
				pos: [
					0,
					-1.3733,
					2.7988
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "6fae9bee-fe21-41c3-8d26-d8dcf0af1c43",
				pos: [
					0,
					-1.3733,
					2.5513
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "efd3b25a-6fe7-44b2-9ea2-0de7888d83ce",
				pos: [
					0,
					-1.3608,
					-2.8425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.44,
					0.1,
					0.075
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "LAU|01|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "2e385f9b-15a9-4fb1-bb37-0fb169fca595",
				pos: [
					0,
					-1.3608,
					0.0562
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "425776dd-3524-4072-bae5-e46df61a4544",
				pos: [
					0,
					-1.3608,
					-0.0037
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "73ce5c5c-805b-4a46-863d-00a1708b4f85",
				pos: [
					0,
					-1.3608,
					1.3563
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "960d9a98-f3ba-41f0-9046-b56943892553",
				pos: [
					0,
					-1.3608,
					1.2963
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "68da100d-a4d3-4841-a95e-2b5fcf6c2289",
				pos: [
					-1.875,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.76,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "8fd7dd77-eec9-459e-968b-1701d72896a8",
				pos: [
					1.875,
					-1.4088,
					0.0006
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7613,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "9dce0e97-4aaf-427e-bfc5-c41f3f5bab11",
				pos: [
					-1.875,
					0.08,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "19113aa3-3cb9-4763-b3e1-03dbb6a04fa1",
				pos: [
					-1.875,
					0.08,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "b8d0c23c-77d5-4044-85a2-63cc56af2ee6",
				pos: [
					1.875,
					0.08,
					2.675
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "75525ba0-817e-4efa-ae35-87d0fc530d8a",
				pos: [
					1.875,
					0.08,
					-1.475
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "ceiling",
				uuid: "a1f71137-e59d-4aff-bdac-8cfeb869986b",
				pos: [
					0,
					1.4463,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					5.7,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "8944cb9b-65ba-4fb7-b76a-45161aa925d8",
		pos: [
			-1.9442,
			1.5238,
			-3.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.8865,
			3.0475,
			7.475
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#ff671f",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "8fa1ffc8-49f6-4df9-8db8-5d748e6032d9",
				pos: [
					-0.0058,
					0.0712,
					-3.6687
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "e2169662-29d0-4c43-82e5-a709f8ab4253",
						pos: [
							0,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.76,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|12|",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "9e9d3242-de28-43e5-be7b-ac18b417904f",
				pos: [
					1.863,
					0.0712,
					-0.0687
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					7.3375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "2d97d099-ab54-4cc0-b4e1-2b62367fa16c",
						pos: [
							2.0687,
							-0.2825,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "668a0cf0-d0b9-42f1-af72-2414697876ed",
				pos: [
					0.063,
					0.0712,
					3.6687
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "77ac586f-3a9c-4773-909b-3c163c5a1033",
				pos: [
					-1.8745,
					0.0712,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.475,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "opening",
						uuid: "7d731e9c-0b94-4496-bc48-3fbe1d35fffc",
						pos: [
							-2,
							-0.2825,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.165,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#cccccc",
						alpha: 0.5,
						rg: true,
						children: [
						],
						type: "Opening"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "cdc0db60-71d0-4b89-b149-d1c28f63f8a3",
				pos: [
					-0.707,
					0.0687,
					-0.1475
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					2.1975,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "e1f13b32-fdbd-493c-8131-c633eb2a1aaf",
				pos: [
					0.3442,
					0.0687,
					0.6025
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					1.405,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "c216c50f-0174-4bdc-9f7d-ae16a03872c1",
				pos: [
					-0.0058,
					0.0687,
					1.3525
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "d2b4ef39-ce22-4ad9-a338-c1a32d071f88",
						pos: [
							-0.2975,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					},
					{
						name: "door",
						uuid: "65e224ec-6f98-4982-ab36-26489f2cc179",
						pos: [
							1.2,
							-0.2245,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "97aa0299-0426-4ab8-b064-6f6aee040a34",
				pos: [
					-0.0058,
					0.0687,
					2.7525
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "e781ee91-6017-4fa9-b2be-dca0ecd44051",
						pos: [
							-0.875,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					},
					{
						name: "door",
						uuid: "72635c29-cbfe-4258-9e0a-d2b22649df70",
						pos: [
							1,
							-0.2425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.21,
							2.09,
							0.095
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DID|02|UK-DID0001",
						type: "Door",
						data: {
							doorType: "Double",
							isEntrance: false
						}
					}
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "9e685198-d2f9-4ba6-8381-0540b0e92830",
				pos: [
					-0.1583,
					0.0687,
					3.2
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.8,
					2.595,
					0.095
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPB|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "10ac00bf-7d49-4593-8328-193556404742",
				pos: [
					-0.0058,
					-1.2613,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "floor",
				uuid: "4f704d94-d913-421e-9a47-c9ba0eec6c16",
				pos: [
					-0.0058,
					-1.2238,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "5aa581e6-c9c5-4341-baaf-78f3055b744a",
				pos: [
					-0.0058,
					-1.4088,
					-3.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "a253a40c-c5c6-4da4-8d8c-a661c1662b04",
				pos: [
					0.0087,
					-1.4088,
					3.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.869,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "f57cf136-f552-4e5e-bf1d-d8fe911aca98",
				pos: [
					-0.0058,
					-1.3733,
					-3.3013
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "7a55e486-dc04-4240-bb04-460d804116ec",
				pos: [
					-0.0058,
					-1.3733,
					-3.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "c6b48b55-9d16-464c-999c-e219931e9d02",
				pos: [
					-0.0058,
					-1.3733,
					3.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "7dd89aae-89c0-476c-9f61-8c76bb65baff",
				pos: [
					-0.0058,
					-1.3733,
					3.3012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "a8fb3f08-168a-4613-bb18-d74e1d89d391",
				pos: [
					-0.0058,
					-1.3608,
					0.805
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "208ebc10-8a66-42b1-9de7-c9ba66eacae4",
				pos: [
					-0.0058,
					-1.3608,
					0.745
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "8387b8e0-6604-4abd-98a3-493e4ca08550",
				pos: [
					-0.0058,
					-1.3608,
					2.105
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "5b04ce0e-d9be-4017-9786-8f3b46980268",
				pos: [
					-0.0058,
					-1.3608,
					2.045
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "b54e92c9-7e43-48e7-aeb0-d69b52e13391",
				pos: [
					-1.8808,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "96ff25c1-6a50-472b-ba6c-855022c46ff8",
				pos: [
					1.8692,
					-1.4088,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "efc33142-b6d9-4e8e-9fb1-f73365e36639",
				pos: [
					-1.8808,
					0.08,
					3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "6de21105-f03c-4a0c-8ce8-1c92f901a198",
				pos: [
					-1.8808,
					0.08,
					-3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "dde97f75-574f-4fc6-b4ab-07981242e6da",
				pos: [
					1.8692,
					0.08,
					3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "fde9a2aa-130c-4aa8-a3e1-18c0d26efc95",
				pos: [
					1.8692,
					0.08,
					-3.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "4471ef40-bdac-473d-88c8-1d9f1b271297",
				pos: [
					-0.0058,
					-1.3733,
					-0.6012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "a2e94244-711e-4d9f-b372-363424040ff6",
				pos: [
					-0.0058,
					-1.3733,
					-0.8488
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "1cb5f962-026a-4fa6-b817-5ddb336799c3",
				pos: [
					-1.8808,
					0.08,
					-0.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "3243c254-b595-403b-945d-8d901367a308",
				pos: [
					1.8692,
					0.08,
					-0.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "2851edba-ce92-4755-a59e-11259aaf68a5",
				pos: [
					-0.0058,
					-1.3608,
					-2.035
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "47e41ce5-147f-45a6-897b-284bd5063dcc",
				pos: [
					-0.0058,
					-1.3608,
					-2.095
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "ceiling",
				uuid: "ee9204a7-fa8e-414a-9135-d0120be14d14",
				pos: [
					-0.0058,
					1.4463,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					7.2,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	},
	{
		name: "module",
		uuid: "d60ba876-a461-4575-a67c-b016b02ed939",
		pos: [
			5.85,
			1.5225,
			-2.7375
		],
		rot: [
			0,
			0,
			0
		],
		size: [
			3.875,
			3.045,
			9.475
		],
		anchor: [
			0.5,
			0.5,
			0.5
		],
		color: "#ff671f",
		alpha: 1,
		rg: true,
		type: "Module",
		children: [
			{
				name: "wall",
				uuid: "153ec901-2538-4200-8078-ae27a26f9562",
				pos: [
					0,
					0.0725,
					-4.6687
				],
				rot: [
					0,
					-180,
					0
				],
				size: [
					3.6,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "44a4e37e-8ff1-4912-870e-79c292ec9b3a",
						pos: [
							0,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.76,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|12|",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "9abf28d5-c219-476e-9ff0-cf4d6bad7b8e",
				pos: [
					1.8688,
					0.0725,
					-0.0687
				],
				rot: [
					0,
					-90,
					0
				],
				size: [
					9.3375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "window",
						uuid: "be01b2da-7f80-4aba-b7cd-b08b3e8ea230",
						pos: [
							3.4937,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1.15,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|14|",
						type: "Window"
					},
					{
						name: "window",
						uuid: "f814996f-5931-447b-89de-e58b76229c0b",
						pos: [
							-0.7063,
							0.1425,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							0.85,
							1.305,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#4b5e82",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "WNF|13|",
						type: "Window"
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "f1f6cb25-27bf-4526-869e-ca80417541f1",
				pos: [
					0.0687,
					0.0725,
					4.6687
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.7375,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "wall",
				uuid: "275903ee-c801-4578-b463-3cef35a91437",
				pos: [
					-1.8688,
					0.0725,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.475,
					2.73,
					0.1375
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#e6e0c8",
				alpha: 1,
				rg: true,
				children: [
					{
						name: "door",
						uuid: "841070aa-bc72-4fec-b335-21006d387685",
						pos: [
							-1,
							-0.227,
							0
						],
						rot: [
							0,
							0,
							0
						],
						size: [
							1,
							2.085,
							0.1375
						],
						anchor: [
							0.5,
							0.5,
							0.5
						],
						color: "#564c83",
						alpha: 0.5,
						rg: true,
						children: [
						],
						modulousId: "DIS|02|UK-DIS0002",
						type: "Door",
						data: {
							doorType: "Single",
							isEntrance: false
						}
					}
				],
				modulousId: "WPA|01|",
				type: "Wall"
			},
			{
				name: "floor",
				uuid: "6dea393b-4f2f-405f-a505-f330d12a5740",
				pos: [
					0,
					-1.26,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.2,
					0.065,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "SCR|01|",
				type: "Floor"
			},
			{
				name: "floor",
				uuid: "ad923da5-d659-4c5e-a193-c200c44dfbad",
				pos: [
					0,
					-1.2225,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.2,
					0.01,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5a6772",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "FFN|01|",
				type: "Floor"
			},
			{
				name: "beam",
				uuid: "ad943285-bda2-4384-a83e-5eb73cc4d278",
				pos: [
					0,
					-1.4075,
					-4.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "ae70ca5d-7cc8-4036-933b-414c01a8fa33",
				pos: [
					0,
					-1.4075,
					4.675
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.84,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "c1014000-6a75-44b4-9bec-2c2fcdf7ca11",
				pos: [
					0,
					-1.372,
					4.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "ffee5088-eae9-481f-8960-4a9a1f33660a",
				pos: [
					0,
					-1.372,
					4.3012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "316815c7-6c7d-45e1-b6c6-3920c8fad4db",
				pos: [
					0,
					-1.3595,
					-0.255
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "e969e66f-ab5d-4e31-8149-ff8db16a4eaf",
				pos: [
					0,
					-1.3595,
					-0.315
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "92a99600-248c-4ef5-a799-23d888c73d55",
				pos: [
					0,
					-1.3595,
					1.045
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "3f7482aa-a898-4b01-8696-cf9ed7446cf5",
				pos: [
					0,
					-1.3595,
					0.985
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "7198b0bd-c298-4650-8ca2-4252b5de0462",
				pos: [
					-1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "8f2f6221-ed24-4fda-b9d0-6c6dc7e9d3cf",
				pos: [
					1.875,
					-1.4075,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.26,
					0.23,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|02|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "e7949692-f0c3-45a5-8b73-d0e582b4091d",
				pos: [
					-1.875,
					0.0812,
					4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "f874d457-95f2-4391-8eb5-2f9f999cce1d",
				pos: [
					1.875,
					0.0812,
					4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "37e73c67-4ece-4582-a4db-80e135948c7a",
				pos: [
					0,
					-1.372,
					-4.3013
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "9b258927-def0-439a-88be-eaded527508a",
				pos: [
					0,
					-1.372,
					-4.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "cf21a46a-7270-4632-932b-f37275b1ab44",
				pos: [
					-1.875,
					0.0812,
					-4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "babc2ee4-8aa2-4533-b33c-c3b6ee627946",
				pos: [
					1.875,
					0.0812,
					-4.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "dfd11fdc-c641-40de-9622-fd3ed7a92c0c",
				pos: [
					0,
					-1.372,
					-1.6012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "5ac55117-94b9-458c-a287-6ac04acd2d8c",
				pos: [
					0,
					-1.372,
					-1.8488
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "9334ab7a-b081-4029-8253-25dd3e3a3cdc",
				pos: [
					-1.875,
					0.0812,
					-1.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "33cae0f0-5b81-4f20-b7fe-666ebbf8cdc8",
				pos: [
					0,
					-1.372,
					2.5487
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "0473d3db-4e5f-4c45-9c54-49cb9cc8b8ff",
				pos: [
					0,
					-1.372,
					2.3012
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.125,
					0.065
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|03|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "194a7720-8f5f-436f-9d7a-f4fbfeb40230",
				pos: [
					-1.875,
					0.0812,
					2.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "column",
				uuid: "973afbb4-8d1f-4c77-b693-c1430465e429",
				pos: [
					1.875,
					0.0812,
					2.425
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "beam",
				uuid: "c08f365f-7dec-4eb9-b106-5f4ed296e096",
				pos: [
					0,
					-1.3595,
					3.485
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "5de8bf4e-347d-487f-a46d-68940f0dc106",
				pos: [
					0,
					-1.3595,
					3.425
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "34cd7425-be26-4955-a533-bb4e08419136",
				pos: [
					0,
					-1.3595,
					-3.195
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "beam",
				uuid: "ffe3dbf0-2ad0-45d4-b232-6b481f2a4274",
				pos: [
					0,
					-1.3595,
					-3.135
				],
				rot: [
					0,
					0,
					0
				],
				size: [
					3.825,
					0.1,
					0.05
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|04|",
				type: "Beam"
			},
			{
				name: "column",
				uuid: "a5ffde60-50f1-4e6f-994b-53bdb2c06b03",
				pos: [
					1.875,
					0.0812,
					-1.725
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					0.18,
					2.7475,
					0.09
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#8e3939",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "PFC|01|",
				type: "Column"
			},
			{
				name: "ceiling",
				uuid: "bc62b5c9-5066-43a3-accd-713fcbc46914",
				pos: [
					0,
					1.445,
					0
				],
				rot: [
					0,
					90,
					0
				],
				size: [
					9.2,
					0.155,
					3.6
				],
				anchor: [
					0.5,
					0.5,
					0.5
				],
				color: "#5ea0bb",
				alpha: 1,
				rg: true,
				children: [
				],
				modulousId: "CPA|05|",
				type: "Ceiling"
			}
		]
	}
];
var data = {
	level: -1,
	levelId: "",
	occupants: 6,
	bedrooms: 3,
	habitableRooms: 4,
	nia: 105.21,
	muscleID: "",
	category: "3B6P",
	closeCorridor: true,
	closeDirection: [
		1,
		0,
		0
	],
	closeLength: 3.875
};
var UK01_3B6P_V1 = {
	name: name,
	uuid: uuid,
	pos: pos,
	rot: rot,
	size: size,
	anchor: anchor,
	color: color,
	alpha: alpha,
	rg: rg,
	type: type,
	children: children,
	data: data
};

export { alpha, anchor, children, color, data, UK01_3B6P_V1 as default, name, pos, rg, rot, size, type, uuid };
//# sourceMappingURL=Scarlet-301-3B6Pv1.json.js.map
